import React, { forwardRef, useEffect, useRef } from "react";

interface PopupPostProps {
  modalRef?: any;
}

const PostPopup = forwardRef(({ modalRef }: PopupPostProps, ref) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.onload = () => {
      new (window as any).daum.Postcode({
        oncomplete: function (data: any) {
          const result = [
            {
              no_post: data.zonecode,
              nm_post: data.zonecode,
              dc_address:
                data.userSelectedType === "J"
                  ? data.jibunAddress
                  : data.roadAddress,
            },
          ];
          modalRef.current?.handleConfirm(true, {
            code: "POPUP_POST",
            data: result,
          });
        },
        width: "100%",
        height: "100%",
      }).embed(elementRef.current);
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div ref={elementRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
});

export default PostPopup;
